/**
 * Demo time anchor.
 *
 * The Balance Summary, Balance Activity, and Payouts demo flows are presented
 * as if "today" is Wednesday, 6 May 2026 at 10:00 in Asia/Kuala_Lumpur (UTC+8).
 *
 * To make every relative-date helper agree on this fiction, we centralize the
 * notion of "now" here. Set DEMO_NOW to `null` to fall back to the real wall
 * clock when the demo period is over.
 */
const DEMO_NOW: Date | null = new Date('2026-05-06T02:00:00Z') // 10:00 MYT

export const nowMs = (): number => (DEMO_NOW ? DEMO_NOW.getTime() : Date.now())

export const now = () => new Date(nowMs())

export const minsAgo = (mins: number) => new Date(nowMs() - mins * 60 * 1000)
export const hoursAgo = (hours: number) =>
  new Date(nowMs() - hours * 60 * 60 * 1000)
export const daysAgo = (days: number) =>
  new Date(nowMs() - days * 24 * 60 * 60 * 1000)
export const daysFromNow = (days: number) =>
  new Date(nowMs() + days * 24 * 60 * 60 * 1000)

export const formatDate = (d: Date) => {
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const formatDateTime = (d: Date) => {
  const date = formatDate(d)
  const hours = String(d.getHours()).padStart(2, '0')
  const mins = String(d.getMinutes()).padStart(2, '0')
  return `${date} ${hours}:${mins}`
}

export const formatTime = (d: Date) => {
  const hours = String(d.getHours()).padStart(2, '0')
  const mins = String(d.getMinutes()).padStart(2, '0')
  return `${hours}:${mins}`
}

export const relativeLabel = (d: Date) => {
  const diffMs = nowMs() - d.getTime()
  const diffSecs = Math.floor(diffMs / 1000)
  const diffMins = Math.floor(diffSecs / 60)
  const diffHours = Math.floor(diffMins / 60)
  const diffDays = Math.floor(diffHours / 24)

  if (diffSecs < 60) return 'Just now'
  if (diffMins < 60) return `${diffMins} minute${diffMins === 1 ? '' : 's'} ago`
  if (diffHours < 24)
    return `${diffHours} hour${diffHours === 1 ? '' : 's'} ago`
  if (diffDays === 1) return 'Yesterday'
  return `${diffDays} days ago`
}

export const randomSecondsAgo = (min = 5, max = 60) => {
  const secs = Math.floor(Math.random() * (max - min + 1)) + min
  return `${secs} seconds ago`
}
